
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import CurrencyCell from "../../component/CurrencyCell";

const columns = [
  //  { field: "DEPOT", label: "DEPOT", align: "right" },
  { field: "ALLOCATION", label: "ALLOCATION/WORKORDER", align: "left" },
  { field: "DEBIT", label: "DEBIT (Rs.) ", align: "right" },
  { field: "CREDIT", label: "CREDIT (Rs.)", align: "right" },
  
  
];

export default function WGRTable({ rows }) {
  return (
    <TableContainer>
      <Table
        size="small"
        stickyHeader
      >
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.field}
                align={column.align}
                sx={{
                  fontWeight: 700,
                  bgcolor: "grey.200",
                  whiteSpace: "nowrap",
                }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row, index) => (
            <TableRow
              key={index}
              hover
              sx={{
                "&:nth-of-type(even)": {
                  bgcolor: "grey.50",
                },
              }}
            >



              
              {/* <TableCell align="right">
                {row.DEPOT}
              </TableCell> */}

              <TableCell align="left"  sx={{ paddingLeft: "100px" }}>
                {row.ALLOCATION}
              </TableCell>

              <TableCell align="right">
                <CurrencyCell
                  value={row.DEBIT}
                />
              </TableCell>

            <TableCell align="right">
                <CurrencyCell
                  value={row.CREDIT}
                />
              </TableCell>

             
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

